import { useState } from 'react';
import { useJournalStatisticsContext } from '../../contexts/journalStatistics.tsx';
const intervalOptions = [
  { value: 1, name: 'This Week' },
  { value: 2, name: 'This Month' },
  { value: 3, name: 'This Year' },
];

const JournalStatisticsHeader = () => {
  const { daysSearchParam, setDaysSearchParam } = useJournalStatisticsContext();
  const [selectedValue, setSelectedValue] = useState({ value: 1 } as any);
  const handleChange = (e) => {
    let dateFrom = new Date();
    let dateTo = new Date();
    switch (e.target.value) {
      case '1': {
        dateFrom.setDate(dateFrom.getDate() - dateFrom.getDay() + 1);
        dateTo.setDate(dateFrom.getDate() + 6);
        break;
      };
      case '2': {
        dateFrom.setDate(1);
        dateTo = new Date(dateFrom.getFullYear(), dateFrom.getMonth() + 1, 0);
        break;
      };
      case '3': {
        dateFrom.setMonth(0, 1);
        dateTo = new Date(dateFrom.getFullYear() + 1, 0, 0);
        break;
      };
    };

    setSelectedValue({ value: e.target.value });
    setDaysSearchParam({
      ...daysSearchParam,
      dateFrom: dateFrom,
      dateTo: dateTo,
    });
  };
  return (
    <div className="d-flex flex-row justify-content-between">
      <h1>Statistics</h1>
      <select
        className="form-select my-auto w-auto"
        value={selectedValue.value}
        onChange={handleChange}
      >
        {
          intervalOptions.map((option) => (
            <option key={option['value']}
              value={option['value']}
            >{option.name}</option>
          ))
        }
      </select>
    </div >
  );
}
export default JournalStatisticsHeader;
